(function() {
  const swiperPrev = document.querySelector('.slide-icon-wrap .icon-prev');
  const slideIcon = new Swiper('.slide-icon', {
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    freeMode: false,
    slidesOffsetAfter:50,
    navigation: {
      nextEl: '.icon-next',
      prevEl: '.icon-prev',
    },
    on: {
      init: function () {
        window.requestAnimationFrame(function() {
          if (swiperPrev) {
            swiperPrev.classList.add('swiper-button-disabled');
          }
        });
      },
      activeIndexChange: function() {
        if (!swiperPrev) {
          return;
        }

        if (this.realIndex == 0) {
          swiperPrev.classList.add('swiper-button-disabled');
        } else {
          swiperPrev.classList.remove('swiper-button-disabled');
        }
      },
    }
  });

  var moSlideIcon01 = new Swiper('.mo-slide-icon01', {
    slidesPerView: 'auto', 
    centeredSlides: false, 
    spaceBetween: 5,
    observer: true,
    observeParents: true,
  });

  var moSlideIcon02 = new Swiper('.mo-slide-icon02', {
    slidesPerView: 'auto', 
    centeredSlides: false, 
    spaceBetween: 5,
    observer: true,
    observeParents: true,
  });

  var slideCollection = new Swiper('.logo_scroll', {
    slidesPerView: 1.8, 
    loop: true,
    speed: 5000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: { 
      769: { slidesPerView: 4.5 },
      1024: { slidesPerView: 5 },
      1400: { slidesPerView: 6 },
    }
  });
})();
